var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcAnnounce = function SvgIcAnnounce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_announce_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.09 1.581A.831.831 0 0 0 8.779.903L4.215 4.141l-2.98.793a.831.831 0 0 0-.617.803v6.649c0 .377.254.706.618.803l2.979.793 4.563 3.238a.831.831 0 0 0 1.313-.678V1.582ZM5.055 5.584 8.428 3.19v11.743l-3.374-2.394a.83.83 0 0 0-.267-.125l-2.506-.667V6.376l2.506-.667a.831.831 0 0 0 .267-.125Zm7.33 2.646a.831.831 0 0 0 0 1.663h3.904a.831.831 0 0 0 0-1.663h-3.905Zm-.69 4.518a.779.779 0 0 1 1.119-.24l2.616 1.783c.38.259.497.786.26 1.178a.779.779 0 0 1-1.118.24l-2.617-1.783a.887.887 0 0 1-.26-1.178Zm1.14-7.148a.78.78 0 0 1-1.125-.203.886.886 0 0 1 .223-1.185l2.617-1.906a.78.78 0 0 1 1.126.203.886.886 0 0 1-.224 1.185L12.834 5.6Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_announce_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgIcAnnounce;